import EDC from '@/components/games/shared/globals';

/**
 *
 */
EDC.Games.AvatarSelect.TypeSelector = function (type, scene, parent, x, y) {
  this.scene = scene;
  this.parent = parent;
  this.x = x;
  this.y = y;
  this.type = type;
  this.imgNormal = null;
  this.imgLight = null;
  this.isActive = false;
  this.cursorManager = scene.cursorManager;
  return this;
};
/**
 *
 */
EDC.Games.AvatarSelect.TypeSelector.prototype.create = function () {
  this.imgNormal = this.scene.add.sprite(0, 0, `type-btn-${this.type}-normal`);
  this.imgLight = this.scene.add.sprite(0, 0, `type-btn-${this.type}-light`);
  this.imgLight.setAlpha(0);
  this.setPosition(this.x, this.y);
  this.parent.add([this.imgNormal, this.imgLight]);

  this.cursorManager.setDefaultDraggableEvents(this.imgNormal);
  this.imgNormal.setInteractive();
  this.imgNormal.on('pointerover', this.onOver, this);
  this.imgNormal.on('pointerout', this.onOut, this);
  this.imgNormal.on('pointerup', this.activate, this);
  return this;
};
/**
 *
 */
EDC.Games.AvatarSelect.TypeSelector.prototype.getWidth = function () {
  return this.imgNormal.displayWidth;
};
/**
 *
 */
EDC.Games.AvatarSelect.TypeSelector.prototype.getPosition = function () {
  return { x: this.imgNormal.x, y: this.imgNormal.y };
};
/**
 *
 */
EDC.Games.AvatarSelect.TypeSelector.prototype.setPosition = function (x, y) {
  this.imgNormal.setPosition(x + this.imgNormal.displayWidth / 2,
    y + this.imgNormal.displayHeight / 2);
  this.imgLight.setPosition(x + this.imgLight.displayWidth / 2,
    y + this.imgLight.displayHeight / 2);
};
/**
 *
 */
EDC.Games.AvatarSelect.TypeSelector.prototype.activate = function () {
  if (this.isActive) return;
  this.isActive = true;
  this.imgLight.setAlpha(1);
  this.scene.events.emit(this.scene.gameConfig.signals.S_FILTER_ACTIVATED, this);
};
/**
 *
 */
EDC.Games.AvatarSelect.TypeSelector.prototype.deactivate = function () {
  this.isActive = false;
  this.imgLight.setAlpha(0);
};
/**
 *
 */
EDC.Games.AvatarSelect.TypeSelector.prototype.onOver = function () {
  if (this.isActive) return;
  this.scene.tweens.add({
    targets: this.imgLight,
    alpha: 1,
    duration: 150,
    ease: 'Linear',
  });
};
/**
 *
 */
EDC.Games.AvatarSelect.TypeSelector.prototype.onOut = function () {
  if (this.isActive) return;
  this.scene.tweens.add({
    targets: this.imgLight,
    alpha: 0,
    duration: 150,
    ease: 'Linear',
  });
};

export default EDC.Games.AvatarSelect.TypeSelector;
